import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Sticky } from 'react-sticky';

import Container from './container';
import { FILTER_ALL, HEADER_HEIGHT } from '../constants';
import DropdownFilter from './dropdown-filter';
import { createDropdownFilterOptions } from '../utils/utils';
import mq from '../utils/mq';

const OuterContainer = styled.div`
  width: 100%;
  height: 81px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  z-index: 5;
`;

const FilterBarContainer = styled.div`
  width: 100%;
  height: 81px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  z-index: 5;
`;

const TitleContainer = styled.div`
  font-weight: bold;
  font-size: 20px;
  line-height: 25px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
  color: #161616;
`;

const FilterOptionsContainer = styled.div`
  height: 100%;
  display: flex;
  z-index: 5;
`;

const DropdownFiltersContainer = styled.div`
  display: flex;
  align-items: center;
`;

export default function CaseStudiesBrowserFilter({
  locations,
  propertyTypes,
  handleFilterUpdate,
  propertyType,
  projectType,
  location
}) {
  const propertyTypeOptions = createDropdownFilterOptions(propertyTypes.edges);
  const locationOptions = createDropdownFilterOptions(locations.edges);
  const systemTypeOptions = useMemo(() => {
    return [
      { name: FILTER_ALL.name, value: '' },
      { name: 'Natural', value: 'natural' },
      { name: 'Mechanical', value: 'mechanical' }
    ];
  }, []);

  function handlePropertyTypeChange(type) {
    handleFilterUpdate('propertyType', type);
    // resetScroll();
  }

  function handleLocationSelect(location) {
    handleFilterUpdate('location', location);
    // resetScroll();
  }

  function handleSystemTypeChange(type) {
    handleFilterUpdate('projectType', type);
    // resetScroll();
  }

  // function resetuScroll() {
  //   scroll.scrollTo(940, {
  //     duration: 600,
  //   });
  // }

  return (
    <Sticky topOffset={848} disableHardwareAcceleration>
      {({ style, isSticky }) => {
        return (
          <OuterContainer
            style={{ ...style, top: isSticky ? HEADER_HEIGHT : 'auto' }}
          >
            <Container>
              <FilterBarContainer>
                <TitleContainer>Case Studies</TitleContainer>
                <FilterOptionsContainer>
                  <DropdownFiltersContainer>
                    <DropdownFilter
                      title={'Sector'}
                      currentOption={propertyType}
                      options={propertyTypeOptions}
                      onChange={handlePropertyTypeChange}
                    />
                    <DropdownFilter
                      title={'Location'}
                      currentOption={location}
                      options={locationOptions}
                      onChange={handleLocationSelect}
                    />
                    <DropdownFilter
                      title={'System Type'}
                      currentOption={projectType}
                      options={systemTypeOptions}
                      onChange={handleSystemTypeChange}
                    />
                  </DropdownFiltersContainer>
                </FilterOptionsContainer>
              </FilterBarContainer>
            </Container>
          </OuterContainer>
        );
      }}
    </Sticky>
  );
}
